<template>
  <v-layout row justify-center class="detalle-pago">
    <v-dialog width="400" v-model="popupPagoEfectivo" class="dialog-pago-efectivo-detalle" persistent>
      <v-card class="pago-efectivo-detalle">
        <v-card-title class="card-title">
          <v-container class="container-title">
            <v-layout>
              <v-flex>
                <span>
                  ¿Cómo funciona?
                </span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text class="card-body">
          <v-container grid-list-md class="text-md-center container-card-body">
            <v-layout row justify-start>
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons/icon-number-1.svg">
                </v-img>
              </v-flex>
              <v-flex>
                <p style="margin-bottom: 0 !important;">Se genera un <b>código de pago (CIP)</b> para que
                  puedas cancelar en <b>Bancos o
                    Asesores</b> afiliados.</p>
              </v-flex>
            </v-layout>
            <v-layout row justify-center>
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons-tarjeta-credito/icons-logos-bancos.svg" style="width: 100%;">
                </v-img>
              </v-flex>
            </v-layout>
            <v-layout row justify-start>
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons/icon-number-2.svg">
                </v-img>
              </v-flex>
              <v-flex>
                <p>Indica que vas a realizar un pago a la empresa <b>Pago Efectivo</b>, presenta el
                  <b>código de pago (CIP)</b> y entrega el importe a pagar.
                </p>
              </v-flex>
            </v-layout>
            <v-layout row justify-start>
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons/icon-number-3.svg">
                </v-img>
              </v-flex>
              <v-flex>
                <p>¡Listo! Tu orden ha sido pagada.</p>
              </v-flex>
            </v-layout>
            <v-layout column justify-center class="recuerda-pago-efectivo">
              <v-flex>
                <p class="p-recuerda-text"> <b> ¡Recuerda que debes pagar este código antes que expire! </b>
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout column align-center>
            <v-flex class="button-detalle-entendido">
              <v-btn @click="closePopup" class="boton-detalle-pago-efectivo">Entendido</v-btn>
            </v-flex>
            <v-flex>
              <v-img>
                <img src="./../../../assets/icons/icon-aviso-adicional.svg">
              </v-img>
            </v-flex>
          </v-layout>
        </v-card-actions>
        <br>
      </v-card>
    </v-dialog>
  </v-layout>

</template>

<script>
export default {
  props: [
    "popupPagoEfectivo"
  ],
  data: () => ({
  }),
  methods: {
    closePopup() {
      this.$emit('popupCodigoPago')
    }
  }

}
</script>

<style scoped>
@import './../../../assets/css/pago-efectivo/pagoEfectivoDetalleStyle.css';
</style>


// WEBPACK FOOTER //
// src/components/payment/pago-efectivo/PagoEfectivoPopupDetalle.vue